import HeroSection from "./HeroSection";

function HomePage({ mapsReady }) {
  return <HeroSection mapsReady={mapsReady} />;
}

export default HomePage;
